import React, { useEffect, useState } from 'react';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { Button, MenuItem } from '@material-ui/core';
import { buildURI } from './core';
import { COLORS } from '../../util/Colors';

const objMappings = [
  'deals',
  'dealTransactions',
  'mappings',
  'voucherTransactions',
  'vouchers',
];

const CSVLink = props => {
  const [uriArray, setUriArray] = useState([]);
  const {
    data,
    headers,
    separator,
    uFEFF,
    enclosingCharacter,
    children,
  } = props;
  useEffect(() => {
    const newUriArray = data.map(newFile =>
      buildURI(newFile, uFEFF, headers, separator, enclosingCharacter),
    );
    setUriArray(newUriArray);
  }, [data, headers, separator, children]);

  const zipFunction = () => {
    const zippy = new JSZip();
    uriArray.forEach((item, i) => zippy.file(`${objMappings[i]}.csv`, item));
    zippy.generateAsync({ type: 'blob' }).then(content => {
      saveAs(content, 'dealMapperData.zip');
    });
  };

  return (
    <MenuItem
      // color="primary"
      // style={{ background: COLORS.green }}
      // variant="contained"
      onClick={zipFunction}
    >
      {children}
    </MenuItem>
  );
};

export default CSVLink;
